import { CheckCircle2, CircleAlert, type LucideIcon } from 'lucide-react';

import type { SourceHealthClass } from '@/lib/api.js';

export interface SourceHealthVisual {
  Icon: LucideIcon;
  colorClass: string;
  aria: string;
  tooltip: string;
}

/**
 * Reine Logik fuer den Health-Indikator: berechnet Icon + Farbe + ARIA aus
 * der `aggregate.worst`-Klasse. Ausgelagert, damit unit-testbar ohne
 * Keycloak-Init.
 */
export function buildVisualForAggregate(
  worst: SourceHealthClass,
  aggregate: { total: number; ok: number; stale: number; error: number },
): SourceHealthVisual {
  const summary = `${aggregate.total} Quellen: ${aggregate.ok} ok, ${aggregate.stale} stehengeblieben, ${aggregate.error} im Fehler.`;
  if (worst === 'error') {
    return {
      Icon: CircleAlert,
      colorClass: 'text-rose-500',
      aria: 'mindestens eine Quelle im Fehlerzustand',
      tooltip: summary,
    };
  }
  if (worst === 'stale') {
    return {
      Icon: CircleAlert,
      colorClass: 'text-amber-500',
      aria: 'mindestens eine Quelle ist stehengeblieben',
      tooltip: summary,
    };
  }
  return {
    Icon: CheckCircle2,
    colorClass: 'text-emerald-500',
    aria: 'alle Quellen liefern Daten',
    tooltip: summary,
  };
}
